// ==================== CALCULATION UTILITIES ====================

/**
 * Calculate Net Words Per Minute (WPM) - Only correct words
 * @param {number} correctWords - Number of correctly typed words
 * @param {number} elapsedSeconds - Time elapsed in seconds
 * @returns {number} Net WPM rounded to nearest integer
 */
export const calculateNetWPM = (correctWords, elapsedSeconds) => {
  const minutes = Math.max(elapsedSeconds / 60, 1 / 60); // Minimum 1 second
  return Math.round(correctWords / minutes);
};


/**
 * Calculate typing accuracy percentage
 * @param {number} correctWords - Number of correctly typed words
 * @param {number} totalWords - Total number of words typed
 * @returns {number} Accuracy percentage (0-100)
 */
export const calculateAccuracy = (correctWords, totalWords) => {
  if (totalWords === 0) return 0;
  return Math.round((correctWords / totalWords) * 100);
};


/**
 * Format seconds into MM:SS format
 * @param {number} seconds - Time in seconds
 * @returns {string} Formatted time string (MM:SS)
 */
export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};


/**
 * Calculate final score - Net WPM (correct words per minute)
 * This is simply the Net WPM value, representing typing speed with only correct words
 *
 * @param {number} correctWords - Number of correctly typed words
 * @param {number} elapsedSeconds - Time elapsed in seconds
 * @returns {number} Net WPM (final score)
 */
export const calculateFinalScore = (correctWords, elapsedSeconds) => {
  return calculateNetWPM(correctWords, elapsedSeconds);
};


/**
 * Generate storage key for localStorage
 * @param {string} interviewId - Interview ID
 * @returns {string} Storage key
 */
export const getStorageKey = (interviewId) => `typing_test_${interviewId}`;
